import styled from "styled-components";

export const GlobalWrapper = styled.div`
  margin: 10px;
`;

export const WrapperInputs = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: 5px;
  padding: 20px;
  h3 {
    font-family: "Rubik", "sans-serif";
    letter-spacing: -0.5px;
    color: gold;
  }
`;

export const CustomButtonGroup = styled.div``;

export const PaymentWrapper = styled.div`
  width: 100%;
  overflow: auto;
`;

export const PaymentTable = styled.table`
  width: 100%;
  &,
  td {
    border: 1px solid ${(props) => props.theme.fontColor};
  }

  td {
    text-align: center;
    padding: 10px;
  }

  tr td:first-child,
  tr,
  th:first-child {
    position: sticky;
    left: 0px;
    background-color: ${(props) => props.theme.bottomColor};
  }

  td:not(:first-child) {
    min-width: 140px;
  }
`;

export const CustomTd = styled.td`
  width: 100px;
`;

export const ModalWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400;
  background-color: ${(props) => props.theme.backgroundColor};
  padding: 15px;
  border-radius: 5px;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  b{ 
    margin: 10px 0;
  }

`

export const CloseBtn = styled.div`
display: flex;
justify-content: flex-end;
button {
  background: unset;
  border: unset;
  padding: 0 10px;
}
`